// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"P2-z","disabled":"Q2-z","seeAllAnswers":"R2-z"};